<template>
  <div class="d-flex align-items-center px-gd-half">
    <svg
      width="72"
      height="32"
      viewBox="0 0 72 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2C0 0.895431 0.895431 0 2 0H70C71.1046 0 72 0.895431 72 2V30C72 31.1046 71.1046 32 70 32H2C0.895431 32 0 31.1046 0 30V2Z"
        fill="#F8F9FA"
      />
      <path
        d="M40 13H43V21.5C43 22.1875 42.75 22.7812 42.25 23.2812C41.75 23.7812 41.1875 24 40.5 24H31.5C30.8125 24 30.2188 23.7812 29.7188 23.2812C29.2188 22.7812 29 22.1875 29 21.5V13H32V12C32 11.2812 32.1562 10.625 32.5312 10C32.875 9.375 33.3438 8.90625 33.9688 8.53125C34.5938 8.1875 35.25 8 36 8C36.7188 8 37.375 8.1875 38 8.53125C38.625 8.90625 39.0938 9.375 39.4688 10C39.8125 10.625 40 11.2812 40 12V13ZM34 12V13H38V12C38 11.4688 37.7812 11 37.4062 10.5938C37 10.2188 36.5312 10 36 10C35.4375 10 34.9688 10.2188 34.5938 10.5938C34.1875 11 34 11.4688 34 12ZM39 15.75C39.1875 15.75 39.375 15.6875 39.5312 15.5312C39.6562 15.4062 39.75 15.2188 39.75 15C39.75 14.8125 39.6562 14.625 39.5312 14.4688C39.375 14.3438 39.1875 14.25 39 14.25C38.7812 14.25 38.5938 14.3438 38.4688 14.4688C38.3125 14.625 38.25 14.8125 38.25 15C38.25 15.2188 38.3125 15.4062 38.4688 15.5312C38.5938 15.6875 38.7812 15.75 39 15.75ZM33 15.75C33.1875 15.75 33.375 15.6875 33.5312 15.5312C33.6562 15.4062 33.75 15.2188 33.75 15C33.75 14.8125 33.6562 14.625 33.5312 14.4688C33.375 14.3438 33.1875 14.25 33 14.25C32.7812 14.25 32.5938 14.3438 32.4688 14.4688C32.3125 14.625 32.25 14.8125 32.25 15C32.25 15.2188 32.3125 15.4062 32.4688 15.5312C32.5938 15.6875 32.7812 15.75 33 15.75Z"
        fill="#6E7881"
      />
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
